import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { I18n } from 'react-redux-i18n'
import { FixedSizeList } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import InfiniteLoader from 'react-window-infinite-loader'

import './styles.scss'
import { company } from 'api'
import operatorActions from 'redux/actions/user'
import { fetchUsers } from 'redux/actions/cv_users'
import { selectUser, updateUser } from 'redux/actions/conversations/user'
import { poolsActions } from 'redux/actions'
import UserCard from 'components/UserCard'
import UserCardOutbound from 'components/Cards/UserCardOutbound'
import ScrollableContent from '../../ScrollableContent'
import SideMenuFilters from '../SideMenuFilters'

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showOnToTop: false
    }

    this.selectUser = this.selectUser.bind(this)
    this.assignToMyself = this.assignToMyself.bind(this)
    this.unassignMe = this.unassignMe.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.handleNextPage = this.handleNextPage.bind(this)
    this.onScrollToTop = this.onScrollToTop.bind(this)
    this.getFilterValue = this.getFilterValue.bind(this)

    this.scrollRef = React.createRef()
  }

  componentDidMount() {
    this.props.fetchUsers()
  }

  componentDidUpdate(prevProps) {
    const { pools: { refreshCounter: prevRefreshCounter } } = prevProps
    const { pools: { refreshCounter } } = this.props

    if (refreshCounter && prevRefreshCounter !== refreshCounter) {
      this.props.fetchUsers()
    }
  }

  componentWillUnmount() {
    this.props.resetRefreshCounter()
  }

  selectUser(user) {
    const {
      tabs: { users },
    } = this.props

    const tabsContainSelectedUser = users.filter((u) => u === user.id).length > 0

    if (users.length < 15 || tabsContainSelectedUser) {
      this.props.history.push(`/dashboard/conversations/users?user_id=${user.id}`)
    }
  }

  updateUser(newData) {
    this.props
      .updateUser(newData)
      .then(() => toast(I18n.t('dashboard_assigned-conversation'), { position: 'top-center' })) // SEND THE TOAST
      .catch(console.error)
  }

  assignToMyself(user) {
    const assignedId = this.props.powerUser._id

    company.assignationsUsers
      .add({
        userId: user.id,
        operator: { id: assignedId, company: user.company },
        operatorIds: [assignedId],
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // this.updateUser({ ...data.results })
        }
      })
      .catch(console.error)
  }

  unassignMe(user) {
    const assignedId = this.props.powerUser._id

    company.assignationsUsers
      .remove({
        userId: user.id,
        operator: { id: assignedId, company: user.company },
        operatorIds: [assignedId],
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // this.updateUser({ ...data.results })
        }
      })
      .catch(console.error)
  }

  handleNextPage(pageCounter) {
    if (!this.props.cv_users.isFetchingUsers) {
      this.props.fetchUsers({ page: pageCounter }, true)
    }
  }

  onScrollToTop(e) {
    e.stopPropagation()

    if (this.scrollRef && this.scrollRef.current) {
      this.scrollRef.current._scrollRef.scrollTop = 0
    }
  }

  getFilterValue(frontOptions) {
    const {
      poolOrder, switchPending, poolNotAssigned, poolCategories,
      poolMainOutbound, poolSelectType, poolChannels, poolBrandsAndDelegations
    } = frontOptions || {}

    if (switchPending) return true
    if (poolNotAssigned) return true
    if (poolMainOutbound) return true
    if (poolSelectType && poolSelectType.value !== 'all') return true
    if (poolOrder && poolOrder !== 'desc') return true
    if (poolChannels && poolChannels.length) return true
    if (poolBrandsAndDelegations && (poolBrandsAndDelegations.brands?.length || poolBrandsAndDelegations.delegations?.length)) return true
    if (poolCategories?.length) return true

    return false
  }

  render() {
    const { showOnToTop } = this.state
    const { powerUser, cv_users, tabs, selectTypeOptions, channelsOptions } = this.props

    if(powerUser.onlyAssignedConversations) {
      return null
    }

    const { activeUser } = tabs
    const { users: notAssignedUsers } = cv_users

    const itemCount = notAssignedUsers.length
    const endLoadMore = itemCount >= cv_users.size
    const currentPage = cv_users.page

    return (
      <div className='animated fadeIn'>
        <div className='sidemenu-container'>
          <div className='users-toggle'>
            <SideMenuFilters
              key='switchSideMenuUsers'
              options={{
                filter: {
                  value: this.getFilterValue(this.props.powerUser.frontOptions),
                  key: 'filter',
                  keys: ['poolOrder', 'switchPending', 'poolNotAssigned', 'poolMainOutbound', 'poolSelectType', 'poolChannels', 'poolBrandsAndDelegations', 'poolCategories'],
                  pool: 'users',
                  showTooltipOn: true,
                  tooltip: I18n.t('conversations_tooltip_filter')
                },
                order: {
                  key: 'poolOrder',
                  value: this.props.powerUser.frontOptions?.poolOrder,
                  tooltip: this.props.powerUser.frontOptions?.poolOrder === 'asc'
                    ? I18n.t('dashboard_order_asc')
                    : I18n.t('dashboard_order_desc')
                },
                notRead: {
                  key: 'switchPending',
                  value: this.props.powerUser.frontOptions?.switchPending,
                  tooltip: I18n.t('conversations_tooltip_not_read'),
                  showTooltipOn: false
                },
                notAssign: {
                  key: 'poolNotAssigned',
                  value: this.props.powerUser.frontOptions?.poolNotAssigned,
                  tooltip: I18n.t('conversations_tooltip_not_assigned'),
                  showTooltipOn: false
                },
                categories: {
                  key: 'poolCategories',
                  value: this.props.powerUser.frontOptions?.poolCategories,
                  tooltip: I18n.t('conversations_tooltip_categories'),
                  showTooltipOn: false
                },
                outbound: {
                  key: 'poolMainOutbound',
                  value: this.props.powerUser.frontOptions?.poolMainOutbound,
                  tooltip: I18n.t('conversations_tooltip_outbound'),
                  showTooltipOn: false
                },
                selectType: {
                  key: 'poolSelectType',
                  value: this.props.powerUser.frontOptions?.poolSelectType
                },
                selectTypeOptions,
                channels: {
                  key: 'poolChannels',
                  value: this.props.powerUser.frontOptions?.poolChannels
                },
                channelsOptions,
                brandsAndDelegations: {
                  key: 'poolBrandsAndDelegations',
                  value: this.props.powerUser.frontOptions?.poolBrandsAndDelegations
                }
              }}
            />
          </div>
          <div className='user-list-height'>
            <AutoSizer>
              {({ height, width }) => (
                <InfiniteLoader
                  isItemLoaded={index => endLoadMore ? true : index < itemCount - 1}
                  itemCount={itemCount}
                  loadMoreItems={() => this.handleNextPage(currentPage + 1)}
                >
                  {({ onItemsRendered, ref }) => (
                    <>
                      <FixedSizeList
                        outerElementType={ScrollableContent}
                        outerRef={this.scrollRef}
                        height={height}
                        width={width}
                        itemSize={86}
                        overscanCount={10}
                        itemKey={(index, data) => data.items[index].id}
                        itemCount={itemCount}
                        itemData={{
                          items: notAssignedUsers,
                          activeUser: activeUser,
                          assignToMyself: this.assignToMyself,
                          unassignMe: this.unassignMe,
                          onSelectUser: this.selectUser,
                          userSessionId: powerUser._id
                        }}
                        onItemsRendered={onItemsRendered}
                        onScroll={(data) => {
                          if (data.scrollOffset > height && !showOnToTop) {
                            this.setState({ showOnToTop: true })
                          } else if (data.scrollOffset === 0 && showOnToTop) {
                            this.setState({ showOnToTop: false })
                          }
                        }}
                        className={'sidemenu-fixed-size-list'}
                        ref={ref}
                      >
                        {RowItem}
                      </FixedSizeList>
                    </>
                  )}
                </InfiniteLoader>
              )}
            </AutoSizer>
            {
              showOnToTop && (
                <div
                  onClick={this.onScrollToTop}
                  className='btn-go-to-top'
                >
                  <i className='fa fa-chevron-up' />
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

function RowItem({ index, style, data }) {
  const user = data.items[index]

  return (
    <div
      style={style}
      className='wrapper-user-card'
    >
      {user.type === 'outbound' ? (
        <UserCardOutbound draft={user} />
      ) : (
        <UserCard
          user={user}
          isActive={data.activeUser === user.id}
          assignToMyself={data.assignToMyself}
          unassignMe={data.unassignMe}
          onClick={data.onSelectUser}
          operatorCanAssignACardToItself={!user.assignedTo.includes(data.userSessionId)}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  cv_users: state.cv_users,
  tabs: state.tabs,
  powerUser: state.user,
  pools: state.pools
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUsers,
      selectUser,
      updateUser,
      updateOperator: operatorActions.updateOperator,
      resetRefreshCounter: poolsActions.resetRefreshCounter
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Index))
